import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { taxRepository } from '../data-access/repositories/TaxRepository'

const base = ['tax']

export const taxQueryConfig = {
  getTax: (id: number) => ({
    queryKey: buildQueryKey([...base, id]),
    queryFn: () => taxRepository.getTax(id),
  }),
}
